jQuery(document).ready(function($) {
  if ($('.post-type-archive-harron_developments').length > 0) {
    // We're on the development archive page, let's run some code
    function fadeInLoader(view) {
      return $('#development-list')
        .addClass('loading')
        .delay(350)
        .queue(function(next) {
          $(this).removeClass('loading')
          if (view === 'detailed') {
            $(this).removeClass('grid-cards')
            $(this).removeClass('map')

            $(this).addClass('grid-detailed')
          } else if (view === 'grid') {
            $(this).removeClass('grid-detailed')
            $(this).removeClass('map')

            $(this).addClass('grid-cards')
          } else if (view === 'map') {
            $(this).removeClass('grid-cards')
            $(this).removeClass('grid-detailed')

            $(this).addClass('map')
          }
          next()
        })
    }

    function setPageTitle(input = false) {
      var activePage = null
      if (!input) {
        activePage = $('#mix-controls')
          .find('.mixitup-control-active > span')
          .html()
      } else {
        activePage = input
      }
      $('title').text(activePage + ' Developments - Harron Homes')
      if (activePage !== 'All') {
        $('h1.page-title').html(activePage + ' - ' + oldTitle)
      } else {
        $('h1.page-title').html(oldTitle)
      }
    }

    // Generate the page title dynamically based on filters
    var pageTitle = null
    var oldTitle = $('h1.page-title').html()
    if ($('#mix-controls').attr('data-default-title') === undefined) {
      pageTitle = $('#mix-controls')
        .find('.mixitup-control-active > span')
        .html()
    } else if ($('#mix-controls').attr('data-default-title').length > 0) {
      pageTitle = $('#mix-controls').attr('data-default-title')
      pageTitle = pageTitle.replace('-', ' ')
      pageTitle = pageTitle.toLowerCase().replace(/\b[a-z]/g, function(txtVal) {
        return txtVal.toUpperCase()
      })
    }
    setPageTitle(pageTitle)

    // Set page title on mixitup filter click
    $('#mix-controls li > button').on('click', function() {
      setPageTitle(
        $(this)
          .find('span')
          .html()
      )
    })

    // Add page swapping menu click handles
    if ($('#development-map').length > 0) {
      // On map view load remove active class for other menu items and apply to map view
      $('#map-view-link')
        .parent()
        .addClass('active')
        .siblings()
        .removeClass('active')
      // Run a function to loop through siblings and change their click action to load the development archive page
      $('#map-view-link')
        .parent()
        .addClass('active')
        .siblings()
        .each(function() {
          var url = $(location).attr('href')
          url = url.split('?')
          url = url[0]
          $(this)
            .find('button')
            .replaceWith(
              '<a href="' +
                url +
                '" class="button has-icon clear">' +
                $(this)
                  .find('button')
                  .html() +
                '</a>'
            )
        })
    } else {
      // This isn't a map view load so let's handle the menu buttons properly for the fader effect
      console.log('conditional loaded')
      $('#grid-view').click(function() {
        $(this)
          .parent()
          .addClass('active')
          .siblings()
          .removeClass('active')
        fadeInLoader('grid')
      })

      $('#detailed-view').click(function() {
        $(this)
          .parent()
          .addClass('active')
          .siblings()
          .removeClass('active')
        fadeInLoader('detailed')
      })
    }

    // Add mixitup stuff
    const developmentList = document.getElementById('development-list')
    const mixControls = document.getElementById('mix-controls')
    var mixer
    var defaultFilterClass
    var findActiveFilter = $('#mix-controls .mixitup-control-active')
    if (findActiveFilter.data('filter') == 'all') {
      defaultFilterClass = 'mix'
    } else {
      defaultFilterClass = findActiveFilter.data('filter').substring(1)
    }
    if (mixControls.dataset.defaultFilter) {
      // Initialise mixitup with default load of the data-default-filter value
      mixer = mixitup(developmentList, {
        load: {
          filter: mixControls.dataset.defaultFilter,
        },
      })
    } else {
      // Initialise mixitup for all developments
      mixer = mixitup(developmentList, {})
    }
    developmentList.addEventListener('mixClick', function(event) {
      // Grab the filter class of whatever has been clicked
      var filterClass = event.detail.originalEvent.target.dataset.filter
        ? event.detail.originalEvent.target.dataset.filter
        : event.detail.originalEvent.target.parentElement.dataset.filter
      // Then update URL
      var urlPath = window.location.pathname
      var urlPrefix = urlPath.split('find-a-home')
      if (filterClass == 'all') {
        filterClass = 'marker'
        window.history.replaceState(null, null, urlPrefix[0] + 'find-a-home/')
      } else {
        // Remove the leading . from the class name
        filterClass = filterClass.substring(1)
        var urlArea = filterClass.split('harron_areas-')
        window.history.replaceState(
          null,
          null,
          urlPrefix[0] + 'find-a-home/' + urlArea[1]
        )
      }
    })

    // Safari only JS to fix SVG weirdness for development logo after filter
    if (
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1
    ) {
      developmentList.addEventListener('mixEnd', function() {
        $('.development__logo svg').each(function() {
          $('.development__logo svg').hide()
          $('.development__logo svg').show()
        })
      })
    }
  }
})
